export type GachaSolanaCluster = "mainnet" | "devnet"

export type GachaSolanaConfigOptions = {
  bffBaseUrl?: string
  cluster?: string
}

export type GachaSolanaConfig = {
  cluster: GachaSolanaCluster
  chain: "solana:mainnet" | "solana:devnet"
  rpcUrl: string
  blockExplorerUrl: string
  usdcMint: string
}

export function getGachaSolanaConfig(
  options: GachaSolanaConfigOptions,
): GachaSolanaConfig {
  const cluster = requireGachaSolanaCluster(options.cluster)
  const rpcUrl = getGachaSolanaRpcProxyUrl(options.bffBaseUrl)

  return {
    cluster,
    chain: cluster === "mainnet" ? "solana:mainnet" : "solana:devnet",
    rpcUrl,
    blockExplorerUrl:
      cluster === "mainnet"
        ? "https://explorer.solana.com"
        : "https://explorer.solana.com/?cluster=devnet",
    usdcMint:
      cluster === "mainnet"
        ? "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v"
        : "Gh9ZwEmdLJ8DscKNTkTqPbNwLNNBjuSzaG9Vp2KGtKJr",
  }
}

function requireGachaSolanaCluster(
  value: string | undefined,
): GachaSolanaCluster {
  if (value === "mainnet" || value === "devnet") {
    return value
  }

  throw new Error(
    "[gacha] Missing required hydrated env: NEXT_PUBLIC_GACHA_SOLANA_CLUSTER",
  )
}

function getGachaSolanaRpcProxyUrl(bffBaseUrl: string | undefined) {
  if (bffBaseUrl) {
    return `${bffBaseUrl.replace(/\/$/, "")}/api/gacha/rpc`
  }

  throw new Error(
    "[gacha] Missing required hydrated env: NEXT_PUBLIC_BFF_BASE_URL",
  )
}
